import { PRODUCT_TYPES_VALUES } from 'constants/dictionaries';

import type { TSelectedProductType } from 'shared/types/TCustomerService';

import { isKnownProductTypeValue } from '../formProductType/knownSelectedProductTypes';

export const convertSelectedProductTypeValue = (value: unknown): TSelectedProductType => {
  if (isKnownProductTypeValue(value)) {
    return value;
  }

  return PRODUCT_TYPES_VALUES.CREDIT;
};
